import { StorageService } from '@empathy/storage-service';
import { EmpathyXAPI } from '../api/api.interfaces';
import { DefaultEmpathyXAPI } from '../api/default-api';
import { AppBuilder, ConfigBuilder } from '../builders';
import {
  ClientEventsDispatcher,
  DefaultClientEventsDispatcherService,
  DefaultPositionService,
  DeviceDetector,
  FacetsReconstructor,
  FacetsReconstructorService,
  hasUserNavigatedBackFromPDP,
  LocalStorageUserService,
  PositionService,
  ProductPageService,
  ScreenWidthDeviceDetector,
  UrlParamProductPageService,
  UserService
} from '../services';
import { StateCacheService } from '../services/state-cache.service';
import { container } from './container';
import { DEPENDENCIES, STORAGE } from './dependencies.const';

export function initContainer() {
  // Bootstrap dependencies
  container.bind<AppBuilder>(DEPENDENCIES.AppBuilder).to(AppBuilder);
  container.bind<ConfigBuilder>(DEPENDENCIES.ConfigBuilder).toConstructor(ConfigBuilder);
  container.bind<EmpathyXAPI>(DEPENDENCIES.EmpathyXAPI).to(DefaultEmpathyXAPI);

  // Rest of services
  container.bind<StateCacheService>(DEPENDENCIES.StateCacheService).to(StateCacheService);
  container.bind<ClientEventsDispatcher>(DEPENDENCIES.ClientEventsDispatcher).to(DefaultClientEventsDispatcherService);
  container.bind<DeviceDetector>(DEPENDENCIES.ScreenWidthDetector).to(ScreenWidthDeviceDetector);
  container.bind<FacetsReconstructor>(DEPENDENCIES.FacetsReconstructor).to(FacetsReconstructorService);
  container.bind<PositionService>(DEPENDENCIES.PositionService).to(DefaultPositionService);
  container.bind<ProductPageService>(DEPENDENCIES.ProductPageService).to(UrlParamProductPageService);
  container.bind<StorageService>(DEPENDENCIES.StorageService)
    .toConstantValue(new StorageService(window.localStorage, 'ebx'))
    .whenTargetNamed(STORAGE.Local);
  container.bind<StorageService>(DEPENDENCIES.StorageService)
    .toConstantValue(new StorageService(window.sessionStorage, 'ebx'))
    .whenTargetNamed(STORAGE.Session);
  container.bind<UserService>(DEPENDENCIES.UserService).to(LocalStorageUserService);
  container.bind<() => boolean>(DEPENDENCIES.HasUserNavigatedBackFromPDP).toConstantValue(hasUserNavigatedBackFromPDP);
}
